import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */

function shouldDisableAutoInstrumentation(getCurrentHub) {
  var clientOptions = _optionalChain([getCurrentHub, 'call', function (_) {
    return _();
  }, 'access', function (_2) {
    return _2.getClient;
  }, 'call', function (_3) {
    return _3();
  }, 'optionalAccess', function (_4) {
    return _4.getOptions;
  }, 'call', function (_5) {
    return _5();
  }]);

  var instrumenter = _optionalChain([clientOptions, 'optionalAccess', function (_6) {
    return _6.instrumenter;
  }]) || 'sentry';
  return instrumenter !== 'sentry';
}

export { shouldDisableAutoInstrumentation };